// export const API = "http://74.64.108.191:1338/api";
export const API = "https://howiestrapi.fly.dev/api";
export const AUTH_TOKEN = "authToken";
export const AUTH_USER = "authUser";
export const BEARER = "Bearer";
